import { CampaignsEmptyState } from 'ui/illustrations';
import { Link } from 'ui/links';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';

export const GoalsEmptyState = () => (
  <PlaceholderState
    title="No goals yet"
    Illustration={CampaignsEmptyState}
    data-test="goal-index-general-error-state"
  >
    <div>
      Track your campaign performance across multiple channels by creating goals. Learn more by
      visiting our{' '}
      <Link size="body1" href="https://support.iterable.com">
        Knowledge Center
      </Link>
      .
    </div>
  </PlaceholderState>
);
